<template>
	<div class="nbc">
        <main>
            <div class="list">
                <h2 style="text-align:center">油耗录入</h2>

                <h4>请选择方式</h4>
                <footer>
                    <van-button type="danger" plain style="width:80%;margin-bottom:30px" @click="go('./clyy')">车辆用油</van-button>
                    <van-button type="danger" plain style="width:80%;margin-bottom:30px" @click="go('./scly')">生产领用</van-button>
                    <van-button type="danger" plain style="width:80%;margin-bottom:30px" @click="go('./qtyy')">其他用油</van-button>
                    <van-button type="danger" plain style="width:80%;margin-bottom:30px" @click="go('./clns')">车用尿素</van-button>
                </footer>

            </div>
        </main>
    </div>
</template>

<script>
	export default{
		data(){
			return{
                show:false,
            }
        },

        mounted() {
        },

        watch: {
            
        },

		methods: {
            go(x) {
                this.$router.push(x)
            },
        }

    }
</script>

<style scoped="scoped" lang='less'>
    .nbc main {
        font-size: 14px;
        padding: 40px 16px 40vh 16px;
        background-color: #FFDCA3;
    }
    .nbc .list {
        background-color: #fff;
        padding: 20px 20px 80px 20px;
    }
    .nbc footer {
        padding-top: 20px;
        text-align: center;
    }
</style>